import React from 'react';
import { useNavigate, useLocation, Navigate, Link} from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import { Container, Divider, Typography, Box } from '@mui/material';
import { styled } from '@mui/material/styles';

import LoginForm from './LoginForm';
import GoogleLoginButton from '../GoogleLogin';
import { HOME_REDIRECT_URL, ONBOARDING_URL } from '../../../utils/redirect-const';
import { login } from '../../../actions/auth-actions';

const StyledContainer = styled(Container)(({ theme }) => ({
  maxWidth: 'sm',
  marginTop: theme.spacing(4),
  padding: theme.spacing(2),
  borderRadius: theme.shape.borderRadius,
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(1),
  },
}));

const BottomActionWrapper = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(3),
  textAlign: 'center',
}));

const OrDivider = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  margin: theme.spacing(2, 0),
  '&::before, &::after': {
    content: '""',
    flex: 1,
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  '&::before': {
    marginRight: theme.spacing(2),
  },
  '&::after': {
    marginLeft: theme.spacing(2),
  },
}));

const Login = ({ auth = { authenticated: false }, login }) => {
  const navigate = useNavigate();
  const location = useLocation();

  if (auth.authenticated) {
    return <Navigate to={location.state?.from || HOME_REDIRECT_URL} />;
  }

  return (
    <StyledContainer>
      <Typography variant="h4" align="center" gutterBottom>
        Logowanie
      </Typography>

      <Box sx={{ mb: 2 }}>
        <GoogleLoginButton />
      </Box>

      <OrDivider>
        <Typography variant="body2" color="text.secondary">
          lub
        </Typography>
      </OrDivider>

      <LoginForm
        onSubmit={login}
      />

      <Divider variant="middle" sx={{ marginY: 3 }} />
      <BottomActionWrapper>
        Nie masz jeszcze konta?{' '}
        <Link
          to={ONBOARDING_URL}
          underline="none"
          variant="body2"
        >
          Stwórz!
        </Link>
      </BottomActionWrapper>
    </StyledContainer>
  );
}

Login.propTypes = {
  auth: PropTypes.shape({
    authenticated: PropTypes.bool,
  }),
  login: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  auth: state.auth || { authenticated: false },
});

const mapDispatchToProps = dispatch => ({
  login: bindActionCreators(login, dispatch),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Login);
